import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

// ** rxjs
import { finalize, tap } from 'rxjs/operators';
import { of } from 'rxjs';

// ** service
import { LayoutService } from '@app/core/services/layout.service';
// ** translate
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-solutions',
	templateUrl: './solutions.component.html',
	styleUrls: ['./solutions.component.scss'],
})
export class SolutionsComponent implements OnInit {
	isBrowser: boolean;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private router: Router,
		private layoutService: LayoutService,
		private translateService: TranslateService
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
	}

	ngOnInit(): void {
		const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
		if (canonical) canonical.href = 'https://www.kunyoutech.com.tw/solutions';
		this.initPage();
	}

	initPage() {
		of(this.layoutService.setPageLoading(true))
			.pipe(finalize(() => this.layoutService.setPageLoading(false)))
			.subscribe();
	}

	/**
	 * 根據當前語系取對應的 hero-wheel 圖片
	 * @returns 圖片路徑
	 */
	getHeroWheelImage(): string {
		const currentLang = this.translateService.currentLang || this.translateService.defaultLang;
		return currentLang === 'en-us' 
			? '/assets/images/solutions/hero-wheel-english.png'
			: '/assets/images/solutions/hero-wheel.png';
	}

	// - 前往解決方案探索內頁
	goToSolutionExplore(type: 'investForensics' | 'securityMonitor' | 'intelGovern' | 'logisticsTransport' | 'coreOpsHR') {
		of(this.layoutService.setPageLoading(true))
			.pipe(tap(() => setTimeout(() => this.router.navigateByUrl(`solutions/explore/${type}`))))
			.subscribe();
	}
}
